// Especialidades atendidas na Telavita
const Specialities = [
    {
        name: "Psicologia",
        role: "psicólogo",
        code: "PSIC",
        profileCode: "TVTVPSIC"
    },
    {
        name: "Psiquiatria",
        role: "psiquiatra",
        code: "PSIQ",
        profileCode: "TVTVPSIQ"
    }
]

export { Specialities }